import { d as t } from "./index-21b082e6.js";
import "./en-4402d6fc.js";
var d = {
  name: "te",
  weekdays: "ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం".split("_"),
  months: "జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్".split("_"),
  weekdaysShort: "ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని".split("_"),
  monthsShort: "జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.".split("_"),
  weekdaysMin: "ఆ_సో_మం_బు_గు_శు_శ".split("_"),
  ordinal: function(_) {
    return _;
  },
  formats: {
    LT: "A h:mm",
    LTS: "A h:mm:ss",
    L: "DD/MM/YYYY",
    LL: "D MMMM YYYY",
    LLL: "D MMMM YYYY, A h:mm",
    LLLL: "dddd, D MMMM YYYY, A h:mm"
  },
  relativeTime: {
    future: "%s లో",
    past: "%s క్రితం",
    s: "కొన్ని క్షణాలు",
    m: "ఒక నిమిషం",
    mm: "%d నిమిషాలు",
    h: "ఒక గంట",
    hh: "%d గంటలు",
    d: "ఒక రోజు",
    dd: "%d రోజులు",
    M: "ఒక నెల",
    MM: "%d నెలలు",
    y: "ఒక సంవత్సరం",
    yy: "%d సంవత్సరాలు"
  }
};
t.locale(d, null, !0);
export {
  d as default
};
